import * as Sentry from '@sentry/react';

const getEnviroment = () => {
  const { hostname } = window.location;
  if (hostname === 'my-repair-partner-portal.i-con.app') {
    return 'production';
  } else if (hostname === 'my-repair-partner-portal-preproduction.i-con.app') {
    return 'preproduction';
  } else {
    return 'staging';
  }
};

Sentry.init({
  dsn: 'https://7b78c5d207b6da3d88d3562b109f5d9c@o1271757.ingest.us.sentry.io/4507655962492928',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  environment: getEnviroment(),
  // Performance Monitoring
  tracesSampleRate: 0.3, //  Capture 30% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/my-repair-partner-portal\.i-con\.app/,
    /^https:\/\/my-repair-partner-portal-preproduction\.i-con\.app/,
    /^https:\/\/my-repair-partner-portal-staging\.i-con\.app/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.0, // This sets the sample rate at 0%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 0.2, // If you're not already sampling the entire session, change the sample rate to 20% when sampling sessions where errors occur.
});
